// PaymentsRegex.js

// Function to extract PayPal username from a URL
function extractPayPalUsername(url) {
    if (!url) {
        return {
            return_string: '',
            error: 'Paypal info is null or undefined'
        };
    }

    // Remove @ if it exists at the start
    url = url.startsWith('@') ? url.slice(1) : url;
    
    // Regular expression to match the PayPal.me URL and capture the username
    const regex = /paypal\.me\/([^?\/]+)/;
    
    // Execute the regex on the input string
    const match = url.match(regex);
    
    // If a match is found, return the captured username, otherwise return the original string
    const final_val = match ? match[1] : url;

    // Regular expression to check if the username contains only letters and numbers
    const validUsernameRegex = /^[a-zA-Z0-9]+$/;

    // Check if final_val is a valid username (only letters and numbers)
    const isValid = validUsernameRegex.test(final_val);

    // Return the final string and the error message based on validation
    return {
        return_string: final_val,
        error: isValid ? '' : 'not a valid username'
    };
}

function extractVenmoUsername(url) {
    if (!url) {
        return {
            return_string: '',
            error: 'Venmo info is null or undefined'
        };
    }

    url = url.startsWith('@') ? url.slice(1) : url;
    // Regular expression to match the Venmo URL and capture the username
    // Username can contain alphanumeric characters, dashes, and underscores
    const regex = /venmo\.com\/([a-zA-Z0-9_-]+)/;

    // Execute the regex on the input string
    const match = url.match(regex);

    // If a match is found, return the captured username, otherwise return the original string
    const final_val = match ? match[1] : url;

    // Regular expression to check if the username contains only alphanumeric, dashes, and underscores
    const validUsernameRegex = /^[a-zA-Z0-9_-]+$/;

    // Check if final_val is a valid username (letters, numbers, dashes, underscores)
    const isValid = validUsernameRegex.test(final_val);

    // Return the final string and the error message based on validation
    return {
        return_string: final_val,
        error: isValid ? '' : 'not a valid username'
    };
}

function extractPhoneOrEmail(input) {
    if (!input) {
        return {
            return_string: '',
            error: 'Phone/Email is null or undefined'
        };
    }
    // Regular expression to match either a phone number or an email
    const phoneRegex = /^(\+?[1-9]\d{0,2})?[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;

    // Remove parentheses, dashes, and spaces from phone numbers (but not from emails)
    let sanitizedInput = input;

    // If the input contains only digits, dashes, spaces, or parentheses, sanitize it
    const sanitizedPhone = sanitizedInput.replace(/[\s\-()]/g, ''); // Remove spaces, dashes, and parentheses for phone numbers

    // Validate as phone or email
    const isPhone = phoneRegex.test(sanitizedPhone);
    const isEmail = emailRegex.test(input); // Use original input for email validation

    // Determine the final value and error message
    let final_val = input;  // default to input
    let error = '';

    if (isPhone) {
        // Check if the sanitized phone number has 15 or fewer digits
        const digitCount = sanitizedPhone.replace(/\D/g, '').length;
        if (digitCount > 11) {
            error = 'phone number exceeds 11 digits';
        } else {
            final_val = sanitizedPhone;
            error = '';
        }
    } else if (isEmail) {
        final_val = input;  // keep email as is
        error = '';
    } else {
        error = 'not a valid phone or email';
    }

    // Return the final validated value and error message
    return { return_string: final_val, error: error };
}

function extractCashTag(url) {
    if (!url) {
        return {
            return_string: '',
            error: 'CashTag is null or undefined'
        };
    }

    // Regular expression to match the Cash App URL and capture the CashTag (after "$")
    // Valid URL characters include letters, numbers, dashes, underscores, periods, and tilde
    const regex = /cash\.app\/\$([a-zA-Z0-9._~-]+)/;

    // Execute the regex on the input string
    const match = url.match(regex);

    // If a match is found, extract the CashTag, otherwise return the original string
    const final_val = match ? match[1] : url;

    // Regular expression to check if the CashTag contains only valid URL characters
    const validUsernameRegex = /^[a-zA-Z0-9._~-]+$/;

    // Check if final_val is valid (letters, numbers, dashes, underscores, periods, or tilde)
    const isValid = validUsernameRegex.test(final_val);

    // Return the final string and the error message based on validation
    return {
        return_string: final_val,
        error: isValid ? '' : 'not a valid username'
    };
}

function extractPhone(input) {
    if (!input) {
        return {
            return_string: '',
            error: 'Phone number is null or undefined'
        };
    }
    // Regular expression to match phone numbers
    const phoneRegex = /^(\+?[1-9]\d{0,2})?[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;

    // Remove parentheses, dashes, and spaces from phone numbers
    let sanitizedPhone = input.replace(/[\s\-()]/g, ''); // Remove spaces, dashes, and parentheses

    // Check if the input is a valid phone number
    const isPhone = phoneRegex.test(sanitizedPhone);

    // Determine the final value and error message
    let final_val = input;  // Default to original input
    let error = '';

    if (isPhone) {
        // Check if the sanitized phone number has 11 or fewer digits
        const digitCount = sanitizedPhone.replace(/\D/g, '').length;
        if (digitCount > 11) {
            error = 'phone number exceeds 11 digits';
        } else if (digitCount < 10) {
            error = 'phone number must be at least digits, include your area code';
        } else {
            final_val = sanitizedPhone;
            error = '';
        }
    } else {
        error = 'not a valid phone number';
    }

    // Return the final validated value and error message
    return { return_string: final_val, error: error };
}


// Export the function to be used in other files
module.exports = {
    extractPayPalUsername,
    extractVenmoUsername,
    extractPhoneOrEmail,
    extractCashTag,
    extractPhone
};
